<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsTabs',
  
})
</script>
<template>
  <Tabs
    v-model="initVal"
    v-bind="$attrs"
    @change="onChange"
  >
    <slot />
  </Tabs>
</template>

<script lang="ts" setup name="TlbsTabs">
import { Tabs } from 'tdesign-vue-next';

interface Props {
  modelValue: string | number;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
});

const emit = defineEmits<(e: 'update:modelValue' | 'change', value: string | number) => void>();

const initVal = ref<string | number>(props.modelValue);

watch(() => props.modelValue, (newVal) => {
  initVal.value = newVal;
  emit('update:modelValue', newVal);
});

const onChange = (value: string | number) => {
  initVal.value = value;
  emit('update:modelValue', value);
  emit('change', value);
};
</script>
